module.exports = __webpack_public_path__ + "static/media/Empolyee-table.cca43147.png";